import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { globals } from 'src/app/globals';
import { CRMStatusPedidoBI, CRMTipoBI } from 'src/app/models/enum';

@Injectable({
  providedIn: 'root'
})
export class CRMBIService {

  constructor(private http: HttpClient) { }

  qtdAcessoUltMes(idIntegrador: number): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/QtdAcessoUltMes`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString())
    });
  }

  ultAcesso(idIntegrador: number): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/UltAcesso`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString())
    });
  }

  ultimos10(idIntegrador: number, tipo: CRMTipoBI, status): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/Ultimos10`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString()).set('tipo', tipo.toString()).set('status', status.toString())
    });
  }

  valorTotal(qtd: number, idIntegrador: number, tipo: CRMTipoBI, geral, status): Observable<any> {
    let parametros = new HttpParams()
      .set('idIntegrador', idIntegrador.toString())
      .set('tipo', tipo.toString())
      .set('geral', geral.toString())
      .set('status', status.toString())

      if (qtd !== null) {
        parametros = parametros.set('qtd', qtd.toString());
      }

    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/ValorTotal`, {
      params: parametros
    });
  }

  qtdTotalOrcPed(qtd: number, idIntegrador: number, tipo: CRMTipoBI, geral, status): Observable<any> {
    let parametros = new HttpParams()
      .set('idIntegrador', idIntegrador.toString())
      .set('tipo', tipo.toString())
      .set('geral', geral.toString())
      .set('status', status.toString())

      if (qtd !== null) {
        parametros = parametros.set('qtd', qtd.toString());
      }

    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/QtdTotalOrcPed`, {
      params: parametros
    });
  }

  ticketMedio(qtd: number, idIntegrador: number, tipo: CRMTipoBI, geral, status): Observable<any> {
    let parametros = new HttpParams()
      .set('idIntegrador', idIntegrador.toString())
      .set('tipo', tipo.toString())
      .set('geral', geral.toString())
      .set('status', status.toString())

      if (qtd !== null) {
        parametros = parametros.set('qtd', qtd.toString());
      }

    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/TicketMedio`, {
      params: parametros
    });
  }

  firstLastOrcPed(idIntegrador: number, tipo: CRMTipoBI, first, status): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/FirstLastOrcPed`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString()).set('tipo', tipo.toString()).set('first', first).set('status', status.toString())
    });
  }
  
  totalPotenciaOrcPed(qtd: number, idIntegrador: number, tipo: CRMTipoBI, geral, status): Observable<any> {
    let parametros = new HttpParams()
      .set('idIntegrador', idIntegrador.toString())
      .set('tipo', tipo.toString())
      .set('geral', geral.toString())
      .set('status', status.toString())

      if (qtd !== null) {
        parametros = parametros.set('qtd', qtd.toString());
      }

    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/TotalPotenciaOrcPed`, {
      params: parametros
    });
  }

  mediaPotenciaOrcPed(qtd: number, idIntegrador: number, tipo: CRMTipoBI, geral, status): Observable<any> {
    let parametros = new HttpParams()
      .set('idIntegrador', idIntegrador.toString())
      .set('tipo', tipo.toString())
      .set('geral', geral.toString())
      .set('status', status.toString())
      
      if (qtd !== null) {
        parametros = parametros.set('qtd', qtd.toString());
      }

    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/MediaPotenciaOrcPed`, {
      params: parametros
    });
  }
  
  maiorOrcPed(idIntegrador: number, tipo: CRMTipoBI, status): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/MaiorOrcPed`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString()).set('tipo', tipo.toString()).set('status', status.toString())
    });
  }

  orcPedCancExp(idIntegrador: number, tipo: CRMTipoBI, exp): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/OrcPedCancExp`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString()).set('tipo', tipo.toString()).set('exp', exp)
    });
  }

  topPainelInversor(idIntegrador: number, tipo: CRMTipoBI, tipoData: number, familia: number): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/TopPainelInversor`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString()).set('tipo', tipo.toString()).set('tipoData', tipoData.toString()).set('familia', familia.toString())
    });
  }

  faixasProdutos(idIntegrador: number, tipo: CRMTipoBI, tipoData: number): Observable<any> {
    return this.http.get<any>(`${globals.apiUrl}/api/CRMBI/FaixasProdutos`, {
      params: new HttpParams().set('idIntegrador', idIntegrador.toString()).set('tipo', tipo.toString()).set('tipoData', tipoData.toString())
    });
  }
}